// @flow

export const FETCH_USERS: 'USER.FETCH_USERS' = 'USER.FETCH_USERS';
export const LOGGING_IN: 'USER.LOGGING_IN' = 'USER.LOGGING_IN';
export const SET_USER: 'USER.SET_USER' = 'USER.SET_USER';
export const CREATE_USER: 'USER.CREATE_USER' = 'USER.CREATE_USER';
export const UPDATE_USER: 'USER.UPDATE_USER' = 'USER.UPDATE_USER';